/**
 * Talker (ADR-001): as traduções ficam como no upstream e a palavra "Chatwoot"
 * vira o nome da instalação (INSTALLATION_NAME) em runtime. Renomear o produto
 * é trocar a configuração, não os arquivos de locale.
 *
 * Só a palavra inteira com maiúscula: `chatwoot.com`, `{latestChatwootVersion}`
 * e afins ficam como estão.
 */
export const withInstallationName = text => {
  const name = window.globalConfig?.INSTALLATION_NAME;
  if (typeof text !== 'string' || !name) return text;
  return text.replace(/\bChatwoot\b/g, name);
};
